import { createFileRoute } from "@tanstack/react-router";
import ChainsawSubcategoryLanding from "@/pages/ChainsawSubcategoryLanding";

export const Route = createFileRoute("/chainsaws/category/$slug")({
  component: ChainsawSubcategoryLanding,
});
